import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteWorkflow, getWorkflowsByDateRange } from '../../../action';
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import Loading from '../../../util/Loading';
import ReactPaginate from 'react-paginate'

export default function WorkFlowDashboard() {
    TabTitle("Workflow Dashboard");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem("user_data"));

    const [workflowData, setWorkflowData] = useState([]);
    const [workflows] = state.workflowAPI.workflows;

    //Import state
    const [rowPerPage] = state.workflowAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.workflowAPI.pageNumber;
    const [totalPages] = state.workflowAPI.totalPages;
    const [setSearch] = state.workflowAPI.search;
    const [callback, setCallback] = state.workflowAPI.callback;

    //Local value states
    let gotDate = new Date();
    let defaultDate = new Date(gotDate).toISOString().slice(0, 10)
    const [startDate, setStartDate] = useState(defaultDate)
    const [endDate, setEndDate] = useState(defaultDate);
    const [trigger, setTrigger] = useState(false)

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const searchByDateHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);

        setTimeout(() => {
            setTrigger(true);
        }, 1000);

        e.target.name === "start_date" ? setStartDate(e.target.value) : setEndDate(e.target.value);
    }

    const onChangeSearchHandler = (start_date, end_date) => {
        getWorkflowsByDateRange(rowPerPage, pageNumber, start_date, end_date, res => {
            setWorkflowData(res);
            setPageNumber(res.totalPages ? res.totalPages : 1)
        })
    }

    const deleteWorkflowHandler = (id) => {
        deleteWorkflow(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => {
        setWorkflowData(workflows);
        if (trigger) {
            onChangeSearchHandler(startDate, endDate);
            setTrigger(false);
        }
    }, [rowPerPage, pageNumber, workflows, trigger])



    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>WorkFlow Details</p>
                    <div className='custom-search'>
                        <input
                            type="date"
                            name="start_date"
                            id="start_date"
                            value={startDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="date"
                            name="end_date"
                            id="end_date"
                            value={endDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search purchase here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/workflow-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    workflowData.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Work Code</th>
                                        <th>Staff Name</th>
                                        <th>Work Type</th>
                                        <th>Route</th>
                                        <th>Assign Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        workflowData.count > 0 ? workflowData.data.map(workflow => (
                                            <tr key={workflow.id}>
                                                <td>{workflow.work_code}</td>
                                                <td>{workflow.staff.first_name + " " + workflow.staff.last_name}</td>
                                                <td>{workflow.work_type}</td>
                                                <td>{workflow.assign_route}</td>
                                                <td>{dateConverter(workflow.assign_date)}</td>
                                                <td>
                                                    <Link to={`/workflow-form/${workflow.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to="#"></Link>
                                                    <button onClick={() => deleteWorkflowHandler(workflow.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={6}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}